export default "__VITE_ASSET__BOaupCcH__"